import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import { PageData, PageSegmentData } from "./page.model";

const ACTION_PREFIX = "[Page]";

export namespace PageAction {
	export const getByKey = createAction(`${ACTION_PREFIX} Get By Key`, (pageSegmentData: PageSegmentData) => ({
		payload: pageSegmentData,
		pageSegmentData,
	}));

	export const getByKeySuccess = createAction(`${ACTION_PREFIX} Get By Key Success`, (pageData: PageData) => ({
		payload: pageData,
		pageData,
	}));

	export const getByKeyFail = createAction(`${ACTION_PREFIX} Get By Key Fail`, (error: AppError) => ({
		payload: error,
		error,
	}));

	export const setByDocumentKey = createAction(
		`${ACTION_PREFIX} Set By Document Key`,
		(pageSegmentData: PageSegmentData) => ({ payload: pageSegmentData, pageSegmentData })
	);

	export const getPageContentFail = createAction(`${ACTION_PREFIX} Get Page Content Fail`, (error: AppError) => ({
		payload: error,
		error,
	}));

	export const setCurrent = createAction(
		`${ACTION_PREFIX} Set Current Page ${SYNC_SUFFIX}`,
		(pageData: PageData) => ({ payload: pageData, pageData })
	);
}
